import useInView from "@/hooks/useInView";

/**
 * Reveal — wraps children in a scroll-triggered fade-up.
 * Lightweight, CSS-only animation triggered by IntersectionObserver.
 */
export default function Reveal({ children, delay = 0, className = "", as: As = "div" }) {
  const [ref, inView] = useInView();
  return (
    <As
      ref={ref}
      style={{ transitionDelay: inView ? `${delay}ms` : "0ms" }}
      className={`${className} transition-all duration-700 ease-out will-change-transform ${
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      {children}
    </As>
  );
}
